// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CustomerActionTypeDTO } from './customer-action-type-dto';

/**
 * 
 * @export
 * @interface OrderCustomerActionDTO
 */
export interface OrderCustomerActionDTO {
    /**
     * 
     * @type {string}
     * @memberof OrderCustomerActionDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCustomerActionDTO
     */
    typeId: OrderCustomerActionDTOTypeIdEnum;
    /**
     * 
     * @type {CustomerActionTypeDTO}
     * @memberof OrderCustomerActionDTO
     */
    type: CustomerActionTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof OrderCustomerActionDTO
     */
    orderCustomerId: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderCustomerActionDTO
     */
    details?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderCustomerActionDTO
     */
    completedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderCustomerActionDTOTypeIdEnum {
    REPOSITABOUTYOU = 'REPOSIT_ABOUT_YOU',
    REPOSITADDRESSHISTORY = 'REPOSIT_ADDRESS_HISTORY',
    REPOSITCONFIRM = 'REPOSIT_CONFIRM',
    REPOSITSIGN = 'REPOSIT_SIGN',
    REPOSITPAY = 'REPOSIT_PAY',
    REPOSITREFERENCING = 'REPOSIT_REFERENCING',
    REPOSITSIGNADDENDUM = 'REPOSIT_SIGN_ADDENDUM',
    CLAIMPAY = 'CLAIM_PAY',
    CLAIMPAYREMAININGBALANCE = 'CLAIM_PAY_REMAINING_BALANCE',
    CLAIMPROPOSALPAYREMAININGBALANCE = 'CLAIM_PROPOSAL_PAY_REMAINING_BALANCE',
    ARBITRATIONPAY = 'ARBITRATION_PAY',
    ARBITRATIONPAYREMAININGBALANCE = 'ARBITRATION_PAY_REMAINING_BALANCE',
    TOPUPPAY = 'TOP_UP_PAY',
    ARBITRATIONADMINPAY = 'ARBITRATION_ADMIN_PAY'
}



